import {Row} from "antd";
import {Form, Formik} from "formik";
import Select from "antd/lib/select";
import React, {ChangeEvent, FC, useEffect, useState} from "react";
import {Button, Col, Container, Label} from '../../styles';
import {FormValues, IFilter} from "../../types";
import {formatDate, formatDateFilter} from "../../../../utils/generalFormat";
import {StringOptions} from "../../../detalhamentoSLC/pagamentos/types";

export const FormFilter: FC<IFilter> = (props: IFilter) => {
  const { getFilters, userType } = props;
  const [paymentTypeFieldValue, setPaymentTypeFieldValue] = useState("");
  const [statusTypeFieldValue, setStatusPaymentTypeFieldValue] = useState(null);
  const [brandCodeFieldValue, setBrandCodeFieldValue] = useState("");
  const [rangeStartReceiveDateInputType, setRangeStartReceiveDateInputType] = useState<"text" | "date">("text");
  const [rangeEndReceiveDateInputType, setRangeEndReceiveDateInputType] = useState<"text" | "date">("text");

  const getInitialValues = (): FormValues => {
    const today = new Date();

    today.setHours(0, 0, 0, 1);
    const startDate = formatDate(today);

    today.setHours(23, 59, 59, 59);
    const finishDate = formatDate(today);

    return {
      merchantId: '',
      rangeStartReceiveDate: startDate,
      rangeEndReceiveDate: finishDate,
      paymentType: '',
      paymentIdentifier: '',
      operationStatus: null,
      isAdmin: userType === 3,
    };
  };

  const handleChangeInitialDate = (
    event: ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void) => {
    const { value } = event.target;
    const date = new Date(value);
    setFieldValue("rangeStartReceiveDate", date);
  };

  const handleChangeEndDate = (
    event: ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void) => {
    const { value } = event.target;
    const date = new Date(value + "T23:59:59Z");
    setFieldValue("rangeEndReceiveDate", date);
  };

  const handleChangeDateInputType = (event:  string) => {
    if (event === 'startDate') {
      if (rangeStartReceiveDateInputType === 'text') setRangeStartReceiveDateInputType('date');
    }
    else if (event === 'endDate') {
      if (rangeEndReceiveDateInputType === 'text') setRangeEndReceiveDateInputType('date');
    }
  };

  const getSettlementReceivables = async (submit: any) => {
    if (submit.startDate === "") {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      submit.startDate = formatDateFilter(date);
    } else {
      submit.startDate = formatDateFilter(submit.startDate);
    }

    if (submit.finishDate === "") {
      const tomorrow = new Date();
      tomorrow.setHours(23, 59, 59, 0);
      submit.finishDate = formatDateFilter(tomorrow);
    } else {
      submit.finishDate = formatDateFilter(submit.finishDate);
    }

    getFilters(submit);
    return submit;
  };

  const paymentOptions: StringOptions[] = [
    { label: "Tipo Pagamento", value: "" },
    { label: "Débito", value: "D" },
    { label: "Crédito Antecipado", value: "A" },
    { label: "Crédito não Antecipado", value: "C" },
  ];

  const brandCodeOptions: StringOptions[] = [
    { label: "Bandeira", value: "" },
    { label: "Visa", value: "004" },
    { label: "Visa débito", value: "026" },
    { label: "Mastercard", value: "003" },
    { label: "Mastercard débito", value: "025" },
    { label: "Elo", value: "008" },
    { label: "Elo débito", value: "027" },
    { label: "Amex", value: "006" },
    { label: "Hipercard", value: "021" },
  ];

  useEffect(() => {
    getSettlementReceivables(getInitialValues());
  }, []);

  return (
    <Container style={{ padding: "0px" }}>
      <Row>
        <Label>Filtrar por:</Label>
      </Row>

      <Formik
        initialValues={getInitialValues()}
        onSubmit={async (values: any) => {
          await getSettlementReceivables(values);
        }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <Row gutter={16}>
              <Col>
                <input
                  type={rangeStartReceiveDateInputType}
                  onChange={(event) => handleChangeInitialDate(event, setFieldValue)}
                  onFocus={() => handleChangeDateInputType("startDate")}
                  name="rangeStartReceiveDate"
                  placeholder="Data Inicial"
                  step="1"
                />
              </Col>

              <Col>
                <input
                  type={rangeEndReceiveDateInputType}
                  onChange={(event) => handleChangeEndDate(event, setFieldValue)}
                  onFocus={() => handleChangeDateInputType("endDate")}
                  name="rangeEndReceiveDate"
                  placeholder="Data Final"
                  step="1"
                />
              </Col>

              {/*<Col>*/}
              {/*  <Field*/}
              {/*    type="text"*/}
              {/*    name="merchantId"*/}
              {/*    placeholder="Cód. Lojista"*/}
              {/*  />*/}
              {/*</Col>*/}

              {/*<Col>*/}
              {/*  <Field*/}
              {/*    type="text"*/}
              {/*    name="paymentIdentifier"*/}
              {/*    placeholder="Identificador Pagamento"*/}
              {/*  />*/}
              {/*</Col>*/}

              <Col>
                <Select
                  defaultValue={paymentTypeFieldValue}
                  style={{width:'100%'}}
                  onChange={(value) => {
                    setFieldValue("paymentType", value);
                    setPaymentTypeFieldValue(value);
                  }}
                  options={paymentOptions}
                />
              </Col>

              <Col>
                <Select
                  defaultValue={brandCodeFieldValue}
                  style={{width:'100%'}}
                  onChange={(value) => {
                    setFieldValue("brandCode", value);
                    setBrandCodeFieldValue(value);
                  }}
                  options={brandCodeOptions}
                />
              </Col>

              <Col>
                <Button htmlType="submit">Consultar</Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  );
}
